export const labelsCaracteristicas = {
  emissor: 'Emissor',
  numeroEmissao: 'Número da Emissão',
  numeroSerie: 'Número de Serie',
  tipoSerie: 'Tipo de Série',
  possuiVasosComunicantes: 'Possui Vasos Comunicantes',
  regimeFiduciario: 'Regime Fiduciário',
  distribuicaoPublica: 'Distribuição Pública',
  negociacaoSecundariaPor: 'Negociação Secundária Por',
  termoSecuritizacaoFormalizado: 'Termo de Securitização Formalizado?',
  depositariaEmissao: 'Depositária Emissão',
  codigoCvmCiaSecuritizadora: 'Código securitizadora na CVM',
  utilizacaoAnuncioInicioDistribuicao: 'Utilização de Anúncio de Início de Distribuição',
  ufLocalEmissao: 'UF do Local de Emissão',
  localEmissao: 'Município da Emissão',
  classificadoraRisco1: 'Classificadora de Risco 1',
  rating1: 'Rating 1',
  classificadoraRisco2: 'Classificadora de Risco 2',
  rating2: 'Rating 2',
  ufLocalPagamento: 'UF de Pagamento',
  localPagamento: 'Local de Pagamento',
  nomeResponsavelPelasInformacoesDRI: 'Nome do Resp. pelas Informações (DRI)',
  emailResponsavelPelasInformacoesDRI: 'Email do Resp. pelas Informações (DRI)',
  tipoLiquidacao: 'Tipo de Liquidação',
  bancoLiquidanteEmissor: 'Banco Liquidante do Emissor',
  cnpjBancoLiquidanteEmissor: 'CNPJ do Banco Liquidante do Emissor',
  codigoBancoContaCorrenteVinculadaEmissao: 'Cód. Banco Vinculado à Emissão',
  numeroAgenciaContaCorrenteVinculadaEmissao: 'Ag. Vinculada à Emissão',
  numeroContaCorrenteVinculadaEmissao: 'Nº C/C Vinculada à Emissão',
  chaveExterna: 'Chave Externa',
  isin: 'Código ISIN',
  escriturador: 'Escriturador',
  razaoSocialEscriturador: 'Razão Social Escriturador',
  cnpjEscriturador: 'CNPJ Escriturador',
  descricaoAdicional: 'Descrição Adicional',
  averbadoEmCartorio: 'Averbado em Cartório',
  custodiante: 'Custodiante',
  registroNaInstituicaoCustodiante: 'Registro na Inst. Custodiante',
  razaoSocialInstituicaoCustodiante: 'Razão Social da Inst. Custodiante',
  cnpjInstituicaoCustodiante: 'CPF/CNPJ do Custodiante',
  garantiaFlutuante: 'Garantia Flutuante',
  tipoGarantia: 'Tipo de Garantia',
  ativoGarantia: 'Ativo da Garantia',
  nomeGarantidor: 'Nome do Garantidor',
  cpfCnpjGarantidor: 'CPF/CNPJ do Garantidor',
  naturezaGarantidor: 'Natureza do Garantidor',
  valorGarantia: 'Valor da Garantia',
  coobrigacao: 'Coobrigação',
  naturezaAgenteFiduciario: 'Natureza do Agente Fiduciário',
  razaoSocialAgenteFiduciario: 'Razão Social Agente Fiduciário',
  cpfCnpjAgenteFiduciario: 'CPF/CNPJ do Agente Fiduciário',
  tipoDistribuicaoPublica: 'Tipo de Distribuição Pública',
  dataEncerramentoDistribuicao: 'Data de Encerramento da Distribuição',
  coordenadores: 'Coordenadores',
  coordenadorLider: 'Coordenador Líder',
  contraparteRecebedora: 'Contraparte Recebedora da Oferta Primária'
};

export const labelsCriteriosRemuneracao = {
  valorNominalUnitarioEmissao: 'Valor Nominal Unitário de Emissão',
  quantidadeEmitida: 'Quantidade emitida',
  volumeEmissao: 'Volume de Emissão',
  quantidadeDepositada: 'Quantidade Depositada na Laqus',
  dataLimiteIntegralizacao: 'Data Limite de Integralização',
  moedaEmissao: 'Moeda de Emissão',
  dataEmissao: 'Data Emissão',
  dataVencimento: 'Data Vencimento',
  cotacaoInicial: 'Cotação inicial',
  dataInicioRentabilidade: 'Data Início Rentabilidade',
  inicioRentabilidade: 'Quando será o início da rentabilidade?',
  indexador: 'Indexador',
  indexadorPorcentagem: '% Indexador',
  defasagemFixing: 'Defasagem/Fixing',
  periodicidadeCorrecao: 'Periodicidade de Correção',
  proRata: 'Pro-rata',
  corrigePeriodoFinal: 'Corrige Período Final?',
  diaAniversario: 'Dia de Aniversário',
  mesAniversario: 'Mês de Aniversário',
  tipoProjecao: 'Tipo de Projeção',
  taxaJurosFixoSpreadPorcentagem: 'Taxa de Juros Fixo/Spread %',
  convencao: 'Convenção',
  cpfCnpjInvestidor: 'CPF/CNPJ Investidor',
  quantidade: 'Quantidade',
  volumeTotal: 'Volume Total',
  banco: 'Banco',
  agencia: 'Agência',
  conta: 'Conta',
  investidores: 'Investidores',
  custoTotal: 'Custo Total',
  feeLaqusBruto: 'Fee Laqus Bruto',
  feeLaqusLiquido: 'Fee Laqus Líquido',
  feeRepasse: 'Fee Repasse',
};

export const labelsEmissor = {
  emissor: 'Emissor',
  codigoExterno: 'Código do CR',
};
